module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"#8b8b8b\" height=\"24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\">\n  <polygon points=\"22.11 7.81 20.41 6.11 12 14.53 3.59 6.11 1.9 7.81 11.97 17.89 12 17.86 12.03 17.89 22.11 7.81\" />\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/arrow-down.svg
// module id = 776
// module chunks = 1